<template>
    <div class="jqs-zonghe-mx">
        <!-- 筛选工具栏 -->
        <div class="nav">
            <span class="btn">刷新</span>
            <span class="label">日期</span>
            <input type="text" placeholder="开始日期" />
            <span class="sep">至</span>
            <input type="text" placeholder="结束日期" />
            <span class="btn">搜索</span>
        </div>

        <!-- 明细表格 -->
        <div class="table-card">
            <div class="card-header">
                <div class="header-title">技巧师综合明细</div>
            </div>
            <div class="table-scroll">
                <el-table :data="[]" border style="width: 100%"
                    :header-cell-style="{ color: '#ffffff', backgroundColor: '#409eff', fontWeight: '600' }">
                    <el-table-column label="彩种"></el-table-column>
                    <el-table-column label="期数"></el-table-column>
                    <el-table-column label="发布时间"></el-table-column>
                    <el-table-column label="发布技巧师类型"></el-table-column>
                    <el-table-column label="EXCEL图表数量"></el-table-column>
                    <el-table-column label="销售额"></el-table-column>
                    <el-table-column label="提成"></el-table-column>
                    <el-table-column label="准确率（自我考核）"></el-table-column>
                    <el-table-column label="操作（平台工作人员复核）"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
// 与全局 commonStyle.scss 及姊妹页（chongzhi_jilu 等）保持一致的视觉变量
$blue-grad: linear-gradient(135deg, #409eff 0%, #2d8cf0 100%);
$card-bg: #fff;
$card-border: #e8eef3;
$card-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
$text-strong: #334155;
$text-weak: #64748b;
$theme: #3f83b3;

.jqs-zonghe-mx {

    // ===== 筛选工具栏 =====
    .nav {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
        background: $card-bg;
        border: 1px solid $card-border;
        border-radius: 14px;
        box-shadow: $card-shadow;
        padding: 16px 18px;
        margin-bottom: 20px;

        // 文本标签（日期 / 至）
        span {
            font-size: 14px;
            color: $text-weak;

            // 操作按钮（刷新 / 搜索）
            &.btn {
                cursor: pointer;
                color: #fff;
                background: $blue-grad;
                padding: 8px 20px;
                border-radius: 8px;
                font-weight: 600;
                letter-spacing: 0.5px;
                box-shadow: 0 2px 8px rgba(64, 158, 255, 0.25);
                transition: transform 0.2s ease, box-shadow 0.2s ease;

                &:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.35);
                }

                &:active {
                    transform: translateY(0);
                }
            }
        }

        // 日期输入框
        input {
            height: 36px;
            width: 140px;
            padding: 0 12px;
            border: 1px solid #d9e2ec;
            border-radius: 8px;
            font-size: 14px;
            color: $text-strong;
            background: #fbfdff;
            outline: none;
            transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

            &::placeholder {
                color: #aab4c0;
            }

            &:focus {
                border-color: $theme;
                background: #fff;
                box-shadow: 0 0 0 3px rgba(63, 131, 179, 0.15);
            }
        }
    }

    // ===== 明细表格卡片 =====
    .table-card {
        background: $card-bg;
        border: 1px solid $card-border;
        border-radius: 16px;
        box-shadow: $card-shadow;
        overflow: hidden;

        .card-header {
            background: $blue-grad;
            padding: 16px 22px;

            .header-title {
                font-size: 16px;
                font-weight: 600;
                color: #fff;
                letter-spacing: 0.5px;
            }
        }

        // 横向滚动容器：小屏下表格内部滚动，避免整页溢出
        .table-scroll {
            width: 100%;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }

        // ElementUI 2.x 表格细节美化
        :deep(.el-table) {
            th {
                background: #f5f8fb;
                color: $text-strong;
                font-weight: 600;
                font-size: 13px;
            }

            td {
                font-size: 13px;
                color: $text-strong;
            }

            .el-table__row {
                transition: background-color 0.2s ease;
            }

            .el-table__row:hover>td {
                background: #f8fafc;
            }
        }
    }
}

// ===== 移动端（≤1200px，与全局 commonStyle.scss 断点保持一致）=====
@media (max-width: 1200px) {
    .jqs-zonghe-mx {
        // 与全局 .w1200 保持一致的内边距
        padding: 0 12px;
        box-sizing: border-box;

        .nav {
            gap: 10px;
            padding: 14px;

            span:not(.btn) {
                font-size: 13px;
            }

            // 输入框占满一行，避免小屏被挤压
            input {
                flex: 1 1 100%;
                width: 100%;
            }

            // 刷新 / 搜索 两个按钮等宽并排
            span.btn {
                flex: 1 1 calc(50% - 5px);
                text-align: center;
                padding: 10px 0;
            }
        }

        .table-card .card-header {
            padding: 14px 16px;
        }
    }
}
</style>
